/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * position object
 * @export
 * @interface PostCorporationsCorporationIdAssetsLocationsPosition
 */
export interface PostCorporationsCorporationIdAssetsLocationsPosition {
    /**
     * x number
     * @type {number}
     * @memberof PostCorporationsCorporationIdAssetsLocationsPosition
     */
    x: number;
    /**
     * y number
     * @type {number}
     * @memberof PostCorporationsCorporationIdAssetsLocationsPosition
     */
    y: number;
    /**
     * z number
     * @type {number}
     * @memberof PostCorporationsCorporationIdAssetsLocationsPosition
     */
    z: number;
}

/**
 * Check if a given object implements the PostCorporationsCorporationIdAssetsLocationsPosition interface.
 */
export function instanceOfPostCorporationsCorporationIdAssetsLocationsPosition(value: object): value is PostCorporationsCorporationIdAssetsLocationsPosition {
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('z' in value) || value['z'] === undefined) return false;
    return true;
}

export function PostCorporationsCorporationIdAssetsLocationsPositionFromJSON(json: any): PostCorporationsCorporationIdAssetsLocationsPosition {
    return PostCorporationsCorporationIdAssetsLocationsPositionFromJSONTyped(json, false);
}

export function PostCorporationsCorporationIdAssetsLocationsPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCorporationsCorporationIdAssetsLocationsPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
    };
}

export function PostCorporationsCorporationIdAssetsLocationsPositionToJSON(json: any): PostCorporationsCorporationIdAssetsLocationsPosition {
    return PostCorporationsCorporationIdAssetsLocationsPositionToJSONTyped(json, false);
}

export function PostCorporationsCorporationIdAssetsLocationsPositionToJSONTyped(value?: PostCorporationsCorporationIdAssetsLocationsPosition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'x': value['x'],
        'y': value['y'],
        'z': value['z'],
    };
}

